import { Component } from "@angular/core";
import { FormBuilder, FormGroup, FormArray, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { PlacePickerComponent } from "src/app/place-picker/place-picker.component";
import { ApiService } from "src/app/shared/services/api.service";
import { ToastrMsgService } from "src/app/shared/services/shared-services/toastr.service";
import { environment } from "src/environments/environment";
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-add-new-organization',
  templateUrl: './add-new-organization.component.html',
  styleUrl: './add-new-organization.component.css'
})
export class AddNewOrganizationComponent {
  orgForm!: FormGroup;
  empORGForm!: FormGroup;
  adminForm!: FormGroup;
  branchForm!: FormGroup;
  empForm!: FormGroup;
  materialsForm!: FormGroup;
  importFrom: FormGroup;
  organizationId: any;

  add = false
  states: any;
  /** Districts for selected state (org address) */
  districts: any[] = [];
  /** Sub-districts / locality options for city dropdown (location API) */
  cities: any[] = [];
  empDistricts: any[] = [];
  empCities: any[] = [];
  roles: any
  roleName: any;
  // Store available states, districts, and cities (sub-districts) for each branch index
  availableStates: any[] = [];
  availableDistricts: any[] = [];
  availableCities: any[] = [];
  selectedFile: File | null = null;
  imagePreview: string | null = null;
  imageBaseUrl = environment.imageBaseUrl;
  domanArray: any;
  profileForm!: FormGroup;
  jobRoles = ['Developer', 'Manager', 'HR', 'Accountant']; // example roles
  // accessTypes = ['Internal', 'External', 'Admin'];
  accessTypes = [
  { id: 1, type: 'Internal' },
  { id: 2, type: 'External' },
  { id: 3, type: 'Admin' }
];
  impTypes = ['Branch', 'User', 'Employee', 'Materials'];
  org_emp = false;
  org_emp_imp = false;
  rowData: any[] = [];
  columnDefs: any[] = [];
  orgname: any;
  orgCode: any;
  orgType: any;
  defaultColDef = { editable: true, resizable: true, sortable: true, filter: true };
  isBranch = false;
  branchList: any;
  domainOptions:any = [];
  newEmployee= false;
organizations: { id: any; value: any }[] = [
  { id: 1, value: 'Principal/PMO' },
  // { id: 2, value: 'SaaS Product Owner' },
  { id: 3, value: 'Contractor/Subcontractor' },
  { id: 4, value: 'Other' }
];
  organizationDesignations: { [key: string]: string[] } = {
  1: [
    'Project Manager',
    'Assistant Project Manager',
    'Planner',
    'Lead Civil Engineer',
    'Site Engineer',
    'Geotechnical Engineer',
    'Surveyor',
    'Construction Manager',
    'Foreman',
    'Supervisor',
    'Safety Officer',
    'Financial Controller',
    'Purchasing Manager',
    'Stores Incharge',
    'Sales Manager',
    'Business Development Officer',
    'HR Manager',
    'Accountant',
    'Cost Analyst'
  ],

  2: [
    'SaaS Product Owner',
    'Sales Manager',
    'Support Analyst',
    'Financial Analyst',
    'Developer',
    'Business Development Officer'
  ],

  3: [
 
    ' Project Manager',
    'Planner',
    'Asphalt Contractor',
    'Concrete Contractor',
    'Surveyor',
    'Supervisor',
    'Worker',
    'Mason',
    'Helper',
    'Equipment Manager',
    'Driver',
    ' Purchasing Agent',
    ' Stores Incharge',
    ' Sales Representative',
    ' Accountant',
    'Payroll Specialist',
    ' Site Supervisor',
    ' Worker',
    ' Mason',
    ' Helper',
    ' Surveyor',
    ' Equipment Operator',
    ' Logistics Coordinator',
    ' Accountant',
    ' Billing Clerk'
  ],

  4: [
    'Community Liaison Officer',
    'Regulatory Financial Auditor',
    'Government Inspector',
    'Environmental Consultant'
  ]
};
designationList: string[] = [];
 branchShow= true
  constructor(
    private formBuilder: FormBuilder,
    private readonly apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private readonly toastrMsgService: ToastrMsgService,
    private sanitizer: DomSanitizer, private dialog: MatDialog
  ) {



  }
  ngOnInit() {
    const user = localStorage.getItem('user') as any;
    const userParse = JSON.parse(user);
    this.roleName = userParse.user.role_name;
    this.domainOptions = userParse.user?.domain.split(",") || [];
    this.route.params.subscribe((params) => {
      this.organizationId = params['id'];
    });
    if (this.organizationId) {
      this.getOrganizationDetails();
      this.fetchBranchList();
    }
    this.getRole()
    this.orgForm = this.formBuilder.group({
      org_name: ["", Validators.required],
      org_type: ["", Validators.required],
      registration_number: [""],
      gst_number: ["", [Validators.required, Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$')]],
      pan_number: ["", [Validators.required, Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]{1}$')]],
      city: ["", Validators.required],
      state: ["", Validators.required],
      district: ["", Validators.required],
      postal_code: ["", Validators.required],
      country: ["", Validators.required],
      domain: ["", Validators.required],
      org_logo: [null],
      address_line_1: ["", Validators.required],
      address_line_2: ["", Validators.required],
      additional_branch: [false],
      company_code: [''],
      primary_contact_name: [''],
      primary_contact_phone: [''],
      primary_contact_email: [''],

    });
    // this.empORGForm = this.formBuilder.group({
    //   full_name: ["", Validators.required],
    //   contact_email: ["", [Validators.required, Validators.email]],
    //   contact_phone: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
    //   companyName: ['',],
    //   companyId: ['',],
    //   branchName: ['',],
    //   branch_id: [''],
    //   id: [''],
    //   employeeId: ['', [Validators.required,]],
    //   emergencyContact: ['', [Validators.maxLength(100)]],
    //   role: ['', Validators.required],
    //   hireDate: ['', Validators.required],
    //   jobRole: ['', Validators.required],
    //   designation: ['', Validators.required],
    
    // });
      this.empORGForm = this.formBuilder.group({
      branch_id: [''],
      full_name: ['', Validators.required],
      specialization: [''],
      contact_email: ['', [Validators.required, Validators.email]],
      contact_phone: ['', Validators.required],
      department: ['', Validators.required],
      state: ['', Validators.required],
      district: ['', Validators.required],
      city: ['', Validators.required],
      postalCode: ['', Validators.required],
      isActive: [1],
      roleId: ['', Validators.required],
      domain: ['',],
      address: ['', Validators.required],
      emailId: ['', ],
      employeeNumber: ['', Validators.required],
      image: [''],
      emergencyContact: this.formBuilder.group({
        name: ['', Validators.required],
        mobile: ['', [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
        email: ['', [Validators.required, Validators.email]]
      }),
      employmentStartDate: ['', Validators.required],
      designation: ['', Validators.required],
      roleInSoftware: ['', Validators.required],
      membershipStartDate: [''],
      membershipEndDate: ['', ],
      employeeId: ['', ],
      id: ['', ],
    });


    this.adminForm = this.formBuilder.group({
      onboarding_date: ["", Validators.required],
      status: [true],
      membership_start_date: [""],
      membership_end_date: [""],
    })
    this.importFrom = this.formBuilder.group({
      branchId: ["", Validators.required],
      improle: ["", Validators.required],
    })
    this.branchForm = this.formBuilder.group({
      additionalBranch: this.formBuilder.array([this.createBranchGroup()])
    });

    this.availableStates[0] = [];
    this.availableDistricts[0] = [];
    this.availableCities[0] = [];

    this.onCountryBChange(0);
    this.loadStatesList();
  }

  private loadStatesList(): void {
    this.apiService.getstates().subscribe({
      next: (res) => {
        this.states = this.asLocArray(res);
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error?.errorMessage);
      },
    });
  }

  private parseMeta(m: any): Record<string, any> {
    if (m == null) return {};
    if (typeof m === 'string') {
      try {
        return JSON.parse(m) as Record<string, any>;
      } catch {
        return {};
      }
    }
    return typeof m === 'object' ? (m as Record<string, any>) : {};
  }

  private asLocArray(res: unknown): any[] {
    return Array.isArray(res) ? res : [];
  }

  /** Restore state → district → city from saved org (district in metadata; legacy: city held district name). */
  private hydrateOrgLocationFromData(data: any): void {
    const state = data.state || '';
    const meta = this.parseMeta(data.metadata);
    let district = meta['district'] || '';
    const savedCity = data.city || '';
    this.orgForm.patchValue({ state, district: '', city: '' });
    this.districts = [];
    this.cities = [];
    if (!state) {
      return;
    }
    this.apiService.getdistricts(state).subscribe({
      next: (dres) => {
        this.districts = this.asLocArray(dres);
        if (!district && savedCity && this.districts.includes(savedCity)) {
          district = savedCity;
        }
        this.orgForm.patchValue({ district });
        if (!district) {
          return;
        }
        this.apiService.getSubdistricts(state, district).subscribe({
          next: (cres) => {
            this.cities = this.asLocArray(cres);
            const cityVal =
              meta['district'] && savedCity && this.cities.includes(savedCity)
                ? savedCity
                : !meta['district'] && district === savedCity
                  ? ''
                  : this.cities.includes(savedCity)
                    ? savedCity
                    : '';
            this.orgForm.patchValue({ city: cityVal });
          },
          error: (err) => {
            console.error(err);
            this.toastrMsgService.error(err.error?.errorMessage || err.error?.message || 'Failed to load cities');
          },
        });
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error?.errorMessage || err.error?.message || 'Failed to load districts');
      },
    });
  }

  /** Staff has no stored district; infer legacy row where city was actually a district name. */
  private hydrateEmpLocation(emp: any): void {
    const state = emp?.state || '';
    const savedCity = emp?.city || '';
    this.empORGForm.patchValue({ state, district: '', city: '' });
    this.empDistricts = [];
    this.empCities = [];
    if (!state) {
      return;
    }
    this.apiService.getdistricts(state).subscribe({
      next: (dres) => {
        this.empDistricts = this.asLocArray(dres);
        let district = '';
        if (savedCity && this.empDistricts.includes(savedCity)) {
          district = savedCity;
        }
        this.empORGForm.patchValue({ district });
        if (!district) {
          return;
        }
        this.apiService.getSubdistricts(state, district).subscribe({
          next: (sres) => {
            this.empCities = this.asLocArray(sres);
            const cityVal =
              district === savedCity ? '' : this.empCities.includes(savedCity) ? savedCity : '';
            this.empORGForm.patchValue({ city: cityVal });
          },
          error: (err) => {
            console.error(err);
            this.toastrMsgService.error(err.error?.errorMessage || err.error?.message || 'Failed to load cities');
          },
        });
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error?.errorMessage || err.error?.message || 'Failed to load districts');
      },
    });
  }

  private patchBranchNonLocation(branchGroup: FormGroup, loc: any): void {
    branchGroup.patchValue({
      lat: loc.lat || '',
      long: loc.long || '',
      postal_code: loc.postal_code || '',
      branch_name: loc.branch_name || '',
      primary_contact_name: loc.primary_contact_name || '',
      primary_contact_email: loc.primary_contact_email || '',
      primary_contact_phone: loc.primary_contact_phone || '',
      branch_id: loc.branch_id || '',
      address_line_1: loc.address_line_1 || '',
      address_line_2: loc.address_line_2 || '',
      pan_number: loc.pan_number || '',
      gst_number: loc.gst_number || '',
      registration_number: loc.registration_number || '',
      domain: loc.domain || '',
    });
  }

  private hydrateBranchLocation(index: number, loc: any, branchGroup: FormGroup): void {
    this.availableStates[index] = [];
    this.availableDistricts[index] = [];
    this.availableCities[index] = [];
    branchGroup.patchValue({ country: loc.country || 'India' });
    this.apiService.getstates().subscribe({
      next: (st) => {
        this.availableStates[index] = this.asLocArray(st);
        const meta = this.parseMeta(loc.metadata);
        let district = meta['district'] || '';
        const savedCity = loc.city || '';
        branchGroup.patchValue({
          state: loc.state || '',
          metadata: loc.metadata ?? null,
        });
        const stVal = loc.state || '';
        if (!stVal) {
          this.patchBranchNonLocation(branchGroup, loc);
          return;
        }
        this.apiService.getdistricts(stVal).subscribe({
          next: (dres) => {
            this.availableDistricts[index] = this.asLocArray(dres);
            if (!district && savedCity && this.availableDistricts[index].includes(savedCity)) {
              district = savedCity;
            }
            branchGroup.patchValue({ district });
            if (!district) {
              this.patchBranchNonLocation(branchGroup, loc);
              return;
            }
            this.apiService.getSubdistricts(stVal, district).subscribe({
              next: (sres) => {
                const subList = this.asLocArray(sres);
                this.availableCities[index] = subList;
                const cityVal =
                  meta['district'] && savedCity && subList.includes(savedCity)
                    ? savedCity
                    : !meta['district'] && district === savedCity
                      ? ''
                      : subList.includes(savedCity)
                        ? savedCity
                        : '';
                branchGroup.patchValue({ city: cityVal });
                this.patchBranchNonLocation(branchGroup, loc);
              },
              error: () => {
                this.patchBranchNonLocation(branchGroup, loc);
              },
            });
          },
          error: () => {
            this.patchBranchNonLocation(branchGroup, loc);
          },
        });
      },
      error: () => {
        this.patchBranchNonLocation(branchGroup, loc);
      },
    });
  }

  // CO-015: Maximum file size limit (5MB)
  private readonly MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB in bytes
  private readonly ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/webp'];

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      // CO-015: Validate file size before upload
      if (file.size > this.MAX_FILE_SIZE) {
        this.toastrMsgService.error('File too large. Maximum file size is 5MB.');
        input.value = ''; // Reset the input
        return;
      }

      // Validate file type
      if (!this.ALLOWED_FILE_TYPES.includes(file.type)) {
        this.toastrMsgService.error('Invalid file type. Only JPEG, PNG, JPG, GIF, and WEBP are allowed.');
        input.value = ''; // Reset the input
        return;
      }

      this.selectedFile = file;
      this.uploadImage(this.selectedFile);
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(this.selectedFile);
    }
  }

  uploadImage(file: any) {
    if (file) {
      this.apiService.uploadContractDocs(file, 'org')?.subscribe({
        next: (res: any) => {
          console.log(res?.org)
          this.orgForm.patchValue({
            org_logo: res?.org,
          });
          console.log(this.orgForm.value.org_logo)

          this.orgForm.get('org_logo')?.updateValueAndValidity();
          this.toastrMsgService.success('Organization logo uploaded successfully');
        },
        error: (err: any) => {
          console.error('Organization logo upload failed', err);
          // Handle specific error messages from backend
          if (err.error?.message) {
            this.toastrMsgService.error(err.error.message);
          } else if (err.error?.error === 'LIMIT_FILE_SIZE') {
            this.toastrMsgService.error('File too large. Maximum file size is 5MB.');
          } else {
            this.toastrMsgService.error('Failed to upload logo. Please try again.');
          }
        }
      });
    }
  }

  // Getter for easy access
  get additionalBranch() {
    return this.branchForm.get('additionalBranch') as FormArray;
  }



  // Create one contact group
  createBranchGroup(): FormGroup {
    return this.formBuilder.group({
      branch_id: [''],
      org_id: [this.organizationId],
      lat: ['', Validators.required],
      long: ['', Validators.required,],
      city: ['', Validators.required,],
      state: ['', Validators.required],
      district: ['', Validators.required],
      country: ['India', Validators.required],
      metadata: [null as any],
      postal_code: ['', Validators.required],
      branch_name: ['', Validators.required],
      primary_contact_name: ["", Validators.required],
      primary_contact_email: ["", [Validators.required, Validators.email]],
      primary_contact_phone: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      registration_number: [""],
      gst_number: ["", [Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$')]],
      pan_number: ["", [Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]{1}$')]],
      domain: ["", Validators.required],
      address_line_1: ["", Validators.required],
      address_line_2: ["", Validators.required],

    });
  }

  // Add new contact
  addBranch() {
    this.additionalBranch.push(this.createBranchGroup());
    const index = this.additionalBranch.length - 1;
    this.availableDistricts[index] = [];
    this.availableCities[index] = [];
    this.onCountryBChange(index);
  }

  // Remove contact at index
  removeBranch(index: number) {
    if (this.additionalBranch.length > 1) {
      this.additionalBranch.removeAt(index);
    }
    this.availableStates.splice(index, 1);
    this.availableDistricts.splice(index, 1);
    this.availableCities.splice(index, 1);
  }




  fetchBranchList() {
    this.apiService.getOrganizationsBranch(this.organizationId).subscribe({
      next: (res: any) => {
        // if (res.data.length != 0) {
        //   this.branchList = res.data
        // }
          if(res.data.length != 0){

          this.branchList=res.data
        }else{

          this.branchShow=false

        }


      },
      error: (err) => {
        console.log('API Error:', err);
        this.toastrMsgService.error(err.error.message);
      },
      complete: () => '',
    });
  }
  getOrganizationDetails() {
    this.apiService.getOrganizations({} as any).subscribe({
      next: (res: any) => {

        const data = res.data.find((project: any) => project.org_id == this.organizationId);
        if (data.additional_branch == "true") {
          this.isBranch = true
        }
        // const lData = data?.branches || [];
        const formatted = data?.branches.map((branch: { domain: string; }) => ({
          ...branch,
          domain: typeof branch.domain === 'string'
            ? branch.domain.split(',').map((d: string) => d.trim())
            : branch.domain  // if already array
        }));
        const lData = formatted || [];

        const branchFormArray = this.additionalBranch;
        branchFormArray.clear();
        this.availableStates = [];
        this.availableDistricts = [];
        this.availableCities = [];
        lData.forEach((loc: any, index: number) => {
          const branchGroup = this.createBranchGroup();
          this.additionalBranch.push(branchGroup);
          this.hydrateBranchLocation(index, loc, branchGroup);
        });

        if (branchFormArray.length === 0) {
          branchFormArray.push(this.createBranchGroup());
          this.availableStates[0] = [];
          this.availableDistricts[0] = [];
          this.availableCities[0] = [];
          this.onCountryBChange(0);
        }



        // this.orgForm.patchValue(data);
        if (typeof data.domain === 'string') {
          this.domanArray = data.domain.split(',').map((s: string) => s.trim());

        } else {
          console.error('data is not a string:', data.domain);
        }

        this.orgForm.patchValue({
          org_name: data.org_name,
          org_type: data.org_type,
          registration_number: data.registration_number,
          gst_number: data.gst_number,
          pan_number: data.pan_number,
          country: data.country,
          postal_code: data.postal_code,
          domain: this.domanArray,
          org_logo: data.org_logo,
          address_line_1: data.address_line_1,
          address_line_2: data.address_line_2,
          company_code: data.company_code,
          additional_branch: data.additional_branch,
          primary_contact_name: data.primary_contact_name,
          primary_contact_phone: data.primary_contact_phone,
          primary_contact_email: data.primary_contact_email,

        });
        this.hydrateOrgLocationFromData(data);
        this.orgname = data.org_name;
        this.orgCode = data.company_code;
        this.orgType = data.org_type;
        this.imagePreview = this.imageBaseUrl + data.org_logo
        const empO = data.staff[0];
        if(empO){
           this.empORGForm.patchValue(empO);
        this.empORGForm.patchValue({
          // full_name: empO?.full_name,
          // contact_email: empO?.contact_email,
          // contact_phone: empO?.contact_phone,
          // branch_id: empO?.branch_id,
          // employeeId: empO.employee_code,
          // emergencyContact: empO.emergencyContact,
          // role: empO.role_id,
          // hireDate: empO.employment_start_date,
          // jobRole: empO.role_in_software,
          // designation: empO.designation,
          // id: empO.id,
            image: empO?.image || '',
          emailId: empO?.contact_email || '',
          employeeNumber: empO?.employee_number,
          employmentStartDate: empO?.employment_start_date || '',
          employmentEndDate: empO?.employment_end_date || '',
          postalCode: empO?.postal_code || '',
          roleInSoftware: empO?.role_in_software || '',
          designation: empO?.designation || '',
          membershipStartDate: empO?.membership_start_date || '',
          membershipEndDate: empO?.membership_end_date || '',
          city: empO?.city || '',
          roleId: empO?.role_id || '',
          id: empO?.id || '',
          employeeId: empO.id,

          emergencyContact: {
            name: empO?.emergency_contact?.name || '',
            mobile: empO?.emergency_contact?.mobile || '',
              email: empO?.emergency_contact?.email || ''
            }
        });
          this.hydrateEmpLocation(empO);
        }
        if (empO) {
          this.onRoleChange(empO.role_id);
        }

        this.adminForm.patchValue({
          onboarding_date: data.onboarding_date,
          membership_start_date: data.membership_start_date,
          membership_end_date: data.membership_end_date,
          status: data.status,
        });

      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () =>'',
    });
  }
  
  onCountryChange() {
    this.districts = [];
    this.cities = [];
    this.orgForm.patchValue({ state: '', district: '', city: '' });
    this.apiService.getstates().subscribe({
      next: (res) => {
        this.states = this.asLocArray(res);
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }

  onStateChange() {
    const state = this.orgForm.get('state')?.value;
    this.orgForm.patchValue({ district: '', city: '' });
    this.districts = [];
    this.cities = [];
    if (!state) {
      return;
    }
    this.apiService.getdistricts(state).subscribe({
      next: (res) => {
        this.districts = this.asLocArray(res);
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error?.errorMessage || err.error?.message || 'Failed to load districts');
      },
      complete: () => '',
    });
  }

  onDistrictChange() {
    const state = this.orgForm.get('state')?.value;
    const district = this.orgForm.get('district')?.value;
    this.orgForm.patchValue({ city: '' });
    this.cities = [];
    if (!state || !district) {
      return;
    }
    this.apiService.getSubdistricts(state, district).subscribe({
      next: (res) => {
        this.cities = this.asLocArray(res);
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error?.errorMessage || err.error?.message || 'Failed to load cities');
      },
      complete: () => '',
    });
  }

  onEmpStateChange() {
    const state = this.empORGForm.get('state')?.value;
    this.empORGForm.patchValue({ district: '', city: '' });
    this.empDistricts = [];
    this.empCities = [];
    if (!state) {
      return;
    }
    this.apiService.getdistricts(state).subscribe({
      next: (res) => {
        this.empDistricts = this.asLocArray(res);
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error?.errorMessage || err.error?.message || 'Failed to load districts');
      },
      complete: () => '',
    });
  }

  onEmpDistrictChange() {
    const state = this.empORGForm.get('state')?.value;
    const district = this.empORGForm.get('district')?.value;
    this.empORGForm.patchValue({ city: '' });
    this.empCities = [];
    if (!state || !district) {
      return;
    }
    this.apiService.getSubdistricts(state, district).subscribe({
      next: (res) => {
        this.empCities = this.asLocArray(res);
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error?.errorMessage || err.error?.message || 'Failed to load cities');
      },
      complete: () => '',
    });
  }


  getRole() {
    this.apiService.getAllRoles().subscribe({
      next: (res: any) => {
        this.roles = res;
      },
      error: (err) => {
        console.error('Error occurred:', err);
      },
      complete: () => {
      }
    });
  }

  onCountryBChange(index: number) {
    const branch = this.additionalBranch.at(index);
    const selectedCountry = branch.get('country')?.value;
    this.apiService.getstates().subscribe({
      next: (res) => {
        this.availableStates[index] = this.asLocArray(res);
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });


    branch.patchValue({ state: '', district: '', city: '' });
    this.availableDistricts[index] = [];
    this.availableCities[index] = [];
  }

  onStateBChange(index: number) {
    const branch = this.additionalBranch.at(index);
    const selectedState = branch.get('state')?.value;
    branch.patchValue({ district: '', city: '' });
    this.availableDistricts[index] = [];
    this.availableCities[index] = [];
    if (!selectedState) {
      return;
    }
    this.apiService.getdistricts(selectedState).subscribe({
      next: (res) => {
        this.availableDistricts[index] = this.asLocArray(res);
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error?.errorMessage || err.error?.message || 'Failed to load districts');
      },
      complete: () => '',
    });
  }

  onDistrictBChange(index: number) {
    const branch = this.additionalBranch.at(index);
    const selectedState = branch.get('state')?.value;
    const selectedDistrict = branch.get('district')?.value;
    branch.patchValue({ city: '' });
    this.availableCities[index] = [];
    if (!selectedState || !selectedDistrict) {
      return;
    }
    this.apiService.getSubdistricts(selectedState, selectedDistrict).subscribe({
      next: (res) => {
        this.availableCities[index] = this.asLocArray(res);
      },
      error: (err) => {
        console.error(err);
        this.toastrMsgService.error(err.error?.errorMessage || err.error?.message || 'Failed to load cities');
      },
      complete: () => '',
    });
  }

  openPicker(index: number, branch: any) {
    const dialogRef = this.dialog.open(PlacePickerComponent, {
      width: '600px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log('Selected Coordinates:', result);
        branch.patchValue({
          lat: result.lat,
          long: result.lng
        });
      }
    });
  }

  addOrg(type: any) {
    // CO-011: Validate company name before submission
    if (!this.orgForm.value.org_name || this.orgForm.value.org_name.trim() === '') {
      this.toastrMsgService.error('Company name is required');
      return;
    }

    // CO-014: Validate domain before submission
    if (!this.orgForm.value.domain || this.orgForm.value.domain.length === 0) {
      this.toastrMsgService.error('Please select a domain');
      return;
    }

    // CO-012: Validate GST format (frontend validation)
    const gstPattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (this.orgForm.value.gst_number && !gstPattern.test(this.orgForm.value.gst_number.toUpperCase())) {
      this.toastrMsgService.error('Invalid GST number format');
      return;
    }

    // Validate PAN format (frontend validation)
    const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (this.orgForm.value.pan_number && !panPattern.test(this.orgForm.value.pan_number.toUpperCase())) {
      this.toastrMsgService.error('Invalid PAN number format');
      return;
    }

    if (type == 'Brnch') {
      this.isBranch = true
    }
    console.log(this.orgForm.value.domain)
    const types = this.orgForm.value.domain
    const result = types.join(', ');
    console.log(result);
    var addUser = {
      "org_name": this.orgForm.value.org_name.trim(),
      "org_type": this.orgForm.value.org_type,
      "registration_number": this.orgForm.value.registration_number,
      "gst_number": this.orgForm.value.gst_number ? this.orgForm.value.gst_number.toUpperCase() : null,
      "city": this.orgForm.value.city,
      "state": this.orgForm.value.state,
      "district": this.orgForm.value.district,
      "postal_code": this.orgForm.value.postal_code,
      "pan_number": this.orgForm.value.pan_number ? this.orgForm.value.pan_number.toUpperCase() : null,
      "country": this.orgForm.value.country,
      "address_line_2": this.orgForm.value.address_line_2,
      "address_line_1": this.orgForm.value.address_line_1,
      "domain": result,
      "org_logo": this.orgForm.value.org_logo,
      "additional_branch": this.orgForm.value.additional_branch,
      "primary_contact_name": this.orgForm.value.primary_contact_name,
      "primary_contact_phone": this.orgForm.value.primary_contact_phone,
      "primary_contact_email": this.orgForm.value.primary_contact_email,
    }

    this.apiService.updateOrganization(this.organizationId, addUser).subscribe({
      next: (res: any) => {
        this.orgname = res.data.org_name;
        this.orgCode = res.data.company_code;
        this.orgType = res.data.org_type;
        this.toastrMsgService.success('Organization Updated successfully');
      },
      error: (err) => {
        // Handle specific validation errors from backend
        const errorMessage = err.error?.message || err.error?.errorMessage || 'Update failed';
        const errorField = err.error?.field;
        
        // CO-011: Company name required
        // CO-012: Invalid GST
        // CO-013: Duplicate PAN
        // CO-014: Domain required
        if (errorField) {
          // Highlight the specific field with error
          this.orgForm.get(errorField)?.setErrors({ serverError: errorMessage });
        }
        
        this.toastrMsgService.error(errorMessage);
      },
      complete: () => '',
    });
  }
  addBranchSubmit() {
    const formattedBranches = this.branchForm.value.additionalBranch.map((branch: any) => {
      const domainStr = Array.isArray(branch.domain) ? branch.domain.join(', ') : branch.domain;
      const md = this.parseMeta(branch.metadata);
      const { metadata: _omit, district: _district, ...rest } = branch;
      return {
        ...rest,
        domain: domainStr,
        metadata: JSON.stringify({ ...md, district: branch.district || null }),
      };
    });
    const formattedBranches1 = this.branchForm.value.additionalBranch
  .filter((branch: any) => branch.branch_id !=='' )
  .map((branch: { domain: any[] }) => ({
    ...branch,
    domain: Array.isArray(branch.domain) ? branch.domain.join(', ') : branch.domain
  }));
  const formattedBranches2 = this.branchForm.value.additionalBranch
  .filter((branch: any) => branch.branch_id ==='' )
  .map((branch: { domain: any[] }) => ({
    ...branch,
    domain: Array.isArray(branch.domain) ? branch.domain.join(', ') : branch.domain
  }));
  console.log(formattedBranches1);
  console.log(formattedBranches2);
    this.apiService.saveOrganizationBranch(formattedBranches).subscribe({
      next: (res: any) => {
        this.toastrMsgService.success('Branch Updated successfully');
        this.fetchBranchList()
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });

  }
  addEmp() {
    // var addUser = {
    //   "employmentStartDate": this.empORGForm.value.hireDate,
    //   "full_name": this.empORGForm.value.full_name,
    //   "contact_email": this.empORGForm.value.contact_email,
    //   "contact_phone": this.empORGForm.value.contact_phone,
    //   "companyId": +this.organizationId,
    //   "branch_id": this.empORGForm.value.branch_id,
    //   "employeeId": this.empORGForm.value.employeeId,
    //   "roleId": this.empORGForm.value.role,
    //   "roleInSoftware": this.empORGForm.value.jobRole,
    //   "designation": this.empORGForm.value.designation,
    // }
    const addUser = this.empORGForm.value;

    if(this.empORGForm.value.id ==''){
    this.apiService.saveStaffEmp(addUser).subscribe({
      next: (res: any) => {
        // Check if payment is required
        if (res.requiresPayment) {
          const amount = res.amount || 0;
          const message = res.paymentPrompt || res.message || `Subscription limit exceeded. Please pay ₹${amount} to activate this staff member.`;
          
          // Show warning message
          this.toastrMsgService.warning(message);
          
          // Prompt admin to pay
          const confirmPayment = confirm(
            `${message}\n\nWould you like to proceed to payment now?`
          );
          
          if (confirmPayment && res.subscription) {
            // Navigate to payment/subscription page with subscription ID
            this.router.navigate(['/home/subscription'], {
              queryParams: {
                subscriptionId: res.subscription.id,
                amount: amount,
                type: 'staff_payment'
              }
            });
          } else {
            // Staff created but inactive
            this.toastrMsgService.info('Staff member created but inactive. Please complete payment to activate.');
          }
        } else {
          this.toastrMsgService.success('Staff added successfully');
        }
      },
      error: (err) => {
        this.toastrMsgService.error(err.error?.errorMessage || err.error?.message || 'Save failed');
      }
    });
    }else{
    this.apiService.updateStaff(this.empORGForm.value.id,addUser).subscribe({
      next: (res) => {
        this.toastrMsgService.success('Staff update successfully');
      },
      error: (err) => {
        this.toastrMsgService.error(err.error?.errorMessage || 'Save failed');
      }
    });
    }

  }




  onFileChange(event: any) {
    const reader = new FileReader();
    const file = event.target.files[0];

    reader.onload = (e: any) => {
      const bstr = e.target.result;
      const workbook = XLSX.read(bstr, { type: 'binary', cellDates: true });

      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

      this.rowData = this.processDateColumns(jsonData);
      this.columnDefs = this.generateColumnDefs(jsonData);
    };

    reader.readAsBinaryString(file);
  }
  processDateColumns(data: any[]): any[] {
    return data.map(row => {
      const newRow: any = { ...row };
      for (const key in row) {
        if (this.isDateString(row[key])) {
          newRow[key] = new Date(row[key]);
        }
      }
      return newRow;
    });
  }

  isDateString(value: any): boolean {
    // Detect ISO or slash-based dates (basic)
    return typeof value === 'string' &&
      (/\d{4}-\d{2}-\d{2}/.test(value) || /\d{2}\/\d{2}\/\d{4}/.test(value));
  }
  generateColumnDefs(data: any[]): any[] {
    if (!data || data.length === 0) return [];
    const firstRow = data[0];
    return Object.keys(firstRow).map(key => {
      const isDateCol = data.some(row => row[key] instanceof Date);
      return {
        headerName: key,
        field: key,
        filter: isDateCol ? 'agDateColumnFilter' : true,
        valueFormatter: isDateCol
          ? (params: any) => this.dateFormatter(params.value)
          : undefined,
      };
    });
  }

  dateFormatter(value: any): string {
    if (!value) return '';
    const date = new Date(value);
    return date.toLocaleDateString('en-GB'); // or use DatePipe
  }


  saveChanges() {
    console.log('Updated Data:', this.rowData);
    // You can send `this.rowData` to the backend
    const params = { type: 'staff', file: this.rowData };
    this.apiService.addImport(params).subscribe({
      next: (res) => {
        this.toastrMsgService.success('Import Updated successfully');
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }

  onRoleChange(selectedOrg: string): void {
    this.designationList = this.organizationDesignations[selectedOrg] || [];
    // this.empORGForm.patchValue({ designation: '' }); 
  }
  getOrgTypeLabel(value: string): string {
  const map: any = {
    cooperative: 'Cooperative (Co-op)',
    corporation: 'Corporation',
    franchise: 'Franchise',
    government_organization: 'Government Organization',
    joint_venture: 'Joint Venture',
    opc: 'One Person Company (OPC)',
    partnership: 'Partnership',
    private_limited: 'Private Limited Company (Pvt Ltd)',
    psu: 'Public Sector Undertaking (PSU)',
    public_limited: 'Public Limited Company (Ltd)',
    sole_proprietorship: 'Sole Proprietorship',
    trust: 'Trust'
  };
  return map[value] || value;
}

}

